'use client';

import Link from 'next/link';
import { useState } from 'react';

const navItems = [
  { label: 'Tecnologia', href: '#tecnologia' },
  { label: 'IA', href: '#ia' },
  { label: 'Produtividade', href: '#produtividade' },
  { label: 'Investimentos', href: '#investimentos' },
  { label: 'DeFi', href: 'https://defi.techeresultado.com.br' },
];

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header
      className="fixed top-0 w-full z-50 border-b transition-all duration-300"
      style={{
        backgroundColor: 'rgba(11, 25, 41, 0.85)',
        backdropFilter: 'blur(20px)',
        borderColor: 'rgba(0, 229, 255, 0.1)',
      }}
    >
      <div
        className="flex justify-between items-center mx-auto h-20"
        style={{
          maxWidth: 'var(--container-max)',
          paddingLeft: 'var(--margin-mobile)',
          paddingRight: 'var(--margin-mobile)',
        }}
      >
        <Link href="/" className="flex items-center gap-2">
          <span
            className="material-symbols-outlined"
            style={{ color: 'var(--cyan-glow)' }}
          >
            hub
          </span>
          <span
            className="text-xl font-bold tracking-tight"
            style={{
              fontFamily: 'var(--font-display)',
              color: 'var(--cyan-glow)',
            }}
          >
            TechResultado
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {navItems.map((item) => (
            <Link
              key={item.label}
              href={item.href}
              className="text-base transition-colors duration-200 hover:text-cyan-glow"
              style={{
                fontFamily: 'var(--font-body)',
                color: 'var(--text-secondary)',
              }}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-4">
          <Link
            href="https://defi.techeresultado.com.br"
            className="hidden md:flex items-center justify-center px-6 py-2 rounded-full border text-xs font-medium transition-all duration-300 hover:bg-cyan-glow/10 active:scale-95"
            style={{
              fontFamily: 'var(--font-mono)',
              borderColor: 'var(--cyan-glow)',
              color: 'var(--cyan-glow)',
              letterSpacing: '0.05em',
            }}
          >
            Acessar
          </Link>

          <button
            className="md:hidden"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Menu"
            style={{ color: 'var(--text-secondary)' }}
          >
            <span className="material-symbols-outlined">menu</span>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div
          className="border-t md:hidden"
          style={{
            backgroundColor: 'var(--surface)',
            borderColor: 'rgba(0, 229, 255, 0.1)',
          }}
        >
          <nav className="flex flex-col px-4 py-6 gap-4">
            {navItems.map((item) => (
              <Link
                key={item.label}
                href={item.href}
                className="text-base"
                style={{
                  fontFamily: 'var(--font-body)',
                  color: 'var(--text-secondary)',
                }}
                onClick={() => setMobileMenuOpen(false)}
              >
                {item.label}
              </Link>
            ))}
            <Link
              href="https://defi.techeresultado.com.br"
              className="mt-2 w-full flex items-center justify-center px-6 py-3 rounded-full border text-xs font-medium"
              style={{
                fontFamily: 'var(--font-mono)',
                borderColor: 'var(--cyan-glow)',
                color: 'var(--cyan-glow)',
                letterSpacing: '0.05em',
              }}
            >
              Acessar
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}
